export default __webpack_public_path__ + "static/logo-airforce-c67ed98b0b837221af5138838209a514.png";